import { render, staticRenderFns } from "./editMiniGameRewardOp.vue?vue&type=template&id=fccec582&lang=pug"
import script from "./editMiniGameRewardOp.vue?vue&type=script&lang=js"
export * from "./editMiniGameRewardOp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports